import type { StencilName } from './stencil.model'

export const supportedStencilContentTypes = [
  'apple-immersive-videos',
  'audio-clips',
  'audio-episodes',
  'audio-series',
  'audio-seasons',
  'author-profiles',
  'collections',
  'energy-drinks',
  'episode-videos',
  'event-details',
  'event-profiles',
  'event-seasons',
  'event-series',
  'externals',
  'external-persons',
  'external-teams',
  'films',
  'images',
  'image-galleries',
  'immersive-3d-models',
  'judges',
  'live-videos',
  'locations',
  'misc',
  'occasions',
  'occasion-campaigns',
  'onsite-promotions',
  'partner-profiles',
  'photographers',
  'person-profiles',
  'preview-clips',
  'project-profiles',
  'rally-drivers',
  'rally-teams',
  'recap-videos',
  'results-standings',
  'seasons',
  'shows',
  'stories',
  'tags',
  'team-profiles',
  'trailer-videos',
  'tv-commercials',
  'tv-partner-channels',
  'video-3d',
  'videos',
  'video-channels',
  'videos-360',
] as const

export type ContentType = typeof supportedStencilContentTypes[number]

export const stencilToContentTypeMapping: Record<StencilName, ContentType> = {
  'apple-immersive-video': 'apple-immersive-videos',
  artist: 'person-profiles',
  athlete: 'person-profiles',
  'audio-clip': 'audio-clips',
  author: 'author-profiles',
  collection: 'tags',
  'content-category': 'tags',
  'content-collection': 'collections',
  'content-hub': 'collections',
  country: 'locations',
  discipline: 'tags',
  'editorial-list': 'collections',
  'energy-drink': 'energy-drinks',
  'episode-video': 'episode-videos',
  'event-details': 'event-details',
  'event-profile': 'event-profiles',
  'event-season': 'event-seasons',
  'event-series': 'event-series',
  'external-content-resource': 'externals',
  'external-person': 'external-persons',
  'external-team': 'external-teams',
  film: 'films',
  geolocation: 'locations',
  image: 'images',
  'image-gallery': 'image-galleries',
  'immersive-3d-model': 'immersive-3d-models',
  judge: 'judges',
  'live-video': 'live-videos',
  misc: 'misc',
  'partner-profile': 'partner-profiles',
  lsc: 'tags',
  'occasion-campaign': 'occasion-campaigns',
  occasion: 'occasions',
  'onsite-promotion': 'onsite-promotions',
  photographer: 'photographers',
  playground: 'tags',
  'podcast-episode': 'audio-episodes',
  'podcast-show': 'audio-series',
  'podcast-season': 'audio-seasons',
  'preview-clip': 'preview-clips',
  'project-profile': 'project-profiles',
  'rally-driver': 'rally-drivers',
  'rally-team': 'rally-teams',
  'recap-video': 'recap-videos',
  'results-and-standings': 'results-standings',
  season: 'seasons',
  show: 'shows',
  story: 'stories',
  team: 'team-profiles',
  'trailer-video': 'trailer-videos',
  'tv-commercial': 'tv-commercials',
  'tv-partner-channel': 'tv-partner-channels',
  'video-3d': 'video-3d',
  video: 'videos',
  'video-channel': 'video-channels',
  'video-vr-360': 'videos-360',
  'virtual-geolocation': 'locations',
  'worldwide-geolocation': 'locations',
}
